import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSearchResults } from "../../services/apiV2";

export const searchByQuery = createAsyncThunk(
  "search/searchByQuery",
  async ({ q }: { q: string }, { rejectWithValue }) => {
    try {
      const res = await getSearchResults(q);
      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
